import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Menu, Dropdown, notification, Empty } from 'antd';
import { ProjectOutlined, UnorderedListOutlined } from '@ant-design/icons';

import { DataDisplay } from 'common/components';
import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';
import RibbonButton from 'common/components/button/RibbonButton';

import Messages from 'i18n/messages/home';
import { useIntl } from 'react-intl';
import gridSelector from 'common/components/grid-view/controllers/selectors';
import * as workflowService from 'services/workflow';

import { useWorkflowTemplateQuery, useTodoListQuery } from 'hooks/workflow';

import './Execute.less';

const MENU_WIDTH = 300;

const onclickTemplate = async (selectedEntityIds, id, intl, updateTodoList) => {
  try {
    const response = await workflowService.startWorkflowService({
      workflowId: id,
      entityIds: selectedEntityIds,
    });
    const { isSuccess, message } = response;

    if (isSuccess) {
      notification.success({
        message: intl.formatMessage(Messages.executeWorkflowSuccess),
      });
      updateTodoList();
    } else {
      notification.error({
        message: message,
      });
    }
  } catch (error) {
    notification.error({
      message: 'Server Error',
    });
  }
};

const ExecuteWorkflow = ({ entityType }) => {
  const selectedEntity = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const selectedEntityIds = selectedEntity?.map((entity) => entity?.id);

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const allItemsOwned = selectedEntity?.every((entityItem) => {
    if (entityItem?.type?.toLowerCase() !== 'member')
      return entityItem?.isOwner;
    else return true;
  });

  const hasProductItem = selectedEntity?.some(
    (entityItem) => entityItem?.type?.toLowerCase() === 'product'
  );

  const disabled =
    selectedEntity.length === 0 || !allItemsOwned || hasProductItem;

  return (
    <>
      <Dropdown
        className='execute-workflow-dropdown'
        arrow
        visible={visible}
        placement='bottomLeft'
        overlay={
          <MenuOptions
            visible={visible}
            entityType={entityType}
            selectedEntityIds={selectedEntityIds}
          />
        }
        disabled={disabled}
        onVisibleChange={onVisibleChange}
      >
        <RibbonButton
          icon={<ProjectOutlined style={{ height: 26 }} />}
          label={Messages.executeWorkflow}
        ></RibbonButton>
      </Dropdown>
    </>
  );
};

const MenuOptions = (props) => {
  const intl = useIntl();

  const { visible, entityType, selectedEntityIds } = props;

  const { data, isLoading } = useWorkflowTemplateQuery({
    entityType,
    enabled: visible,
  });

  const { invalidateTodoList } = useTodoListQuery({
    enabled: false,
  });
  const workflowTemplates = data?.templateModels || [];

  const updateTodoList = () => {
    invalidateTodoList();
  };

  return (
    <Menu className='execute-workflow-dropdown__menu scroller'>
      <DataDisplay
        loading={isLoading}
        data={workflowTemplates}
        style={{ width: MENU_WIDTH }}
      >
        {workflowTemplates?.map((workflowTemplate, index) => {
          return (
            <Menu.Item key={index} style={{ backgroundColor: 'inherit' }}>
              <ButtonSmallIcon
                icon={<UnorderedListOutlined />}
                textDisplay={workflowTemplate?.name}
                style={{ width: MENU_WIDTH - 32 }} //* 32 is padding
                onClick={() =>
                  onclickTemplate(
                    selectedEntityIds,
                    workflowTemplate?.id,
                    intl,
                    updateTodoList
                  )
                }
              />
            </Menu.Item>
          );
        })}
      </DataDisplay>
    </Menu>
  );
};

export default ExecuteWorkflow;
